import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import moment from "moment";

function EditDetails(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const { swimmer } = location.state;
  const [team, setTeam] = useState([]);
  const [teamID, setTeamId] = useState([]);

  const token = GetStorage.get("xAuthToken");
  useEffect(() => {
    AdminTeam();
    userGet();
    AdminTeamId();
  }, []);

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState("");
  const [birthday, setDob] = useState(null);
  const [team_id, setTeam_id] = useState("");
  const [group_id, setGroup_id] = useState("");
  const [user, setUser] = useState({});

  const userGet = () => {
    http
      .get(`api/admin/swimmer/${swimmer.id}?token=${token}`)
      .then((res) => {
        setUser(res.data);
        setTeam_id(res.data.team_id);
        setGroup_id(res.data.group_id);
        setMessage(res.data.firstname);
        setMessages(res.data.lastname);
        setDob(res.data.birthday);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  const AdminTeam = () => {
    http
      .get(`api/admin/team?token=${token}`)
      .then((res) => {
        console.log("admin team", res.data);
        setTeam(res.data);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  const AdminTeamId = () => {
    http
      .get(`api/teamgroup/byteam/${swimmer.team_id}?token=${token}`)
      .then((res) => {
        console.log("admin team id", res.data);
        setTeamId(res.data);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };

  const handleChanges = (event) => {
    console.log("on change value", event.target.value);
    setTeam_id(event.target.value);
    http
      .get(`api/teamgroup/byteam/${event.target.value}?token=${token}`)
      .then((res) => {
        console.log("admin team select", res.data);
        setTeamId(res.data);
        if (res.data.length) {
          setGroup_id(res.data[0].id);
        }
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };

  const onSubmit = async (values) => {
    console.log("value of submit button ===>", birthday);

    http
      .put(`api/admin/swimmer/${swimmer.id}?token=${token}`, {
        firstname: message,
        lastname: messages,
        gender: user.gender,
        team_id: team_id,
        group_id: group_id,
        birthday: birthday
      })
      .then((res) => {
        console.log("response", res.data);
        showToast("success", res.data.message);
        navigate(`/teamshark/${team_id}`, {
          state: {
            previousPath: location.pathname
          }
        })
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);

            setError(error.response.data.message);
          }
        }
      });
  };

  const handleChangess = (event) => {
    setMessage(event.target.value);
  };
  const handleChangesss = (event) => {
    setMessages(event.target.value);
  };
  const GroupHandler = (event) => {
    console.log("group handler", event.target.value);
    setGroup_id(event.target.value);
  };

  const handleGenderChange = (event) => {
    setUser((prevUser) => ({
      ...prevUser,
      gender: event.target.value,
    }));
  };

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(`/teamshark/${team_id}`, {
                      state: {
                        previousPath: location.pathname
                      }
                    })}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Edit Details</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>

            <Formik onSubmit={onSubmit}>
              {({ handleSubmit }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add">
                      <h5 className="my-3">General Info</h5>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>First Name</label>
                              <input
                                type="text"
                                id="message"
                                name="message"
                                onChange={handleChangess}
                                value={message}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Last Name</label>
                              <input
                                type="text"
                                id="messages"
                                name="messages"
                                onChange={handleChangesss}
                                value={messages}
                                className="custom_input form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Gender</label>
                              <select
                                name="gender"
                                value={user.gender}
                                onChange={handleGenderChange}
                                className="form-control custom_input w-100"
                              >
                                <option
                                  value="MALE"
                                  selected={
                                    swimmer.gender === "MALE" ? true : false
                                  }
                                >
                                  Male
                                </option>
                                <option
                                  value="FEMALE"
                                  selected={
                                    swimmer.gender === "FEMALE" ? true : false
                                  }
                                >
                                  Female
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label> Date of Birth</label>
                              <input
                                type="date"
                                id="birthday"
                                name="birthday"
                                onChange={(e) => {
                                  setDob(e.target.value)
                                }}
                                value={moment(birthday).format("yyyy-MM-DD")}
                                className="custom_input form-control"
                              />

                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Team</label>
                              <select
                                onChange={handleChanges}
                                name="Team"
                                className="form-control custom_input w-100"
                              >
                                {team?.map((item, i) => (
                                  <option
                                    key={i}
                                    value={item.id}
                                    selected={
                                      item.id === swimmer.team_id ? true : false
                                    }
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Group</label>
                              <select
                                onChange={GroupHandler}
                                name="group"
                                className="form-control custom_input w-100"
                              >
                                {teamID?.map((item, i) => (
                                  <option
                                    key={i}
                                    value={item.id}
                                    selected={
                                      item.id === swimmer.group_id
                                        ? true
                                        : false
                                    }
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <button
                                onClick={() => navigate(`/teamshark/${team_id}`, {
                                  state: {
                                    previousPath: location.pathname
                                  }
                                })}
                                type="button"
                                className=" them_btn_ouline  "
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="them_btn "
                                onClick={onSubmit}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>

        <div
          className="modal fade starrating new_team_add"
          id="new_team_add"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="new_team_add"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="new_team_add">
                  Super Admin Login
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className="raing_star">
                  <p>Please enter your login credentials to proceed.</p>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email ID"
                        />{" "}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="Password"
                          className="form-control"
                          placeholder="Password"
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-top-0">
                  <button type="button" className="them_btn_ouline ">
                    Cancel
                  </button>
                  <button type="button" className="them_btn ">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}

export default EditDetails;
